import * as generalTypes from "../types/general";

export const showLoading = () => (dispatch) => {
  dispatch({ type: generalTypes.SHOW_LOADING, payload: null });
};
export const hideLoading = () => (dispatch) => {
  dispatch({ type: generalTypes.HIDE_LOADING, payload: null });
};
